import styled from "styled-components";
import Dropdown from "./Dropdown";
import { useEffect, useRef, useState } from "react";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { useMouseHover } from "../../hooks/useMouseHover";
import { Link } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";

const StyledMenuItems = styled.li`
  position: relative;
  font-size: 1.1em;
  margin-left: 2rem;

  a,
  button {
    display: block;
    font-size: inherit;
    color: inherit;
    text-decoration: none;
    text-align: left;
    padding: 0.7rem 1rem;

    &:hover {
      color: var(--color-witron-blue);
    }
  }

  button {
    color: inherit;
    font-size: inherit;
    border: none;
    background-color: transparent;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
  }
`;

const MenuItemContent = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${(props) => (props.$hasIcon ? "0" : "1em")};

  .menu-icon {
    margin-right: 0.5em;
    display: ${(props) => (props.$hasIcon ? "inline" : "none")};
  }
`;

const Arrow = styled(IoIosArrowDown)`
  /* Add your custom styles for the icon here if needed */
  vertical-align: middle;
  width: 0.8em;
  margin-left: 0.3em; // Adjust spacing as needed
`;

function MenuItems({ items, depthLevel }) {
  const [dropdown, setDropdown] = useState(false);
  const hasSubmenu = !!items.submenu;

  const openDropdown = () => setDropdown(true);
  const closeDropdown = () => setDropdown(false);

  const ref = useOutsideClick(closeDropdown);
  useMouseHover(ref, openDropdown, closeDropdown);

  const hasIcon = !!items.icon;

  return (
    <StyledMenuItems ref={ref}>
      {hasSubmenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={() => setDropdown((prev) => !prev)}
          >
            <MenuItemContent $hasIcon={hasIcon}>
              <span className="menu-icon">{items.icon}</span>
              {items.title}
            </MenuItemContent>
            <Arrow $depthLevel={depthLevel} $hasSubmenu={hasSubmenu} />
          </button>
          <Dropdown
            submenus={items.submenu}
            dropdown={dropdown}
            depthLevel={depthLevel + 1}
          />
        </>
      ) : (
        <Link to={items.url}>
          <MenuItemContent $hasIcon={hasIcon}>
            <span className="menu-icon">{items.icon}</span>
            {items.title}
          </MenuItemContent>
        </Link>
      )}
    </StyledMenuItems>
  );
}

export default MenuItems;
